import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "bg-slate-700 text-slate-100 -mx-2 h-full"
};
const _hoisted_2 = {
  class: "py-4"
};
const _hoisted_3 = {
  class: "text-3xl flex-center"
};
const _hoisted_4 = {
  class: "flex-center mb-4"
};
const _hoisted_5 = {
  class: "flex-center text-4xl mono uppercase mb-4"
};
const _hoisted_6 = {
  class: "flex-center flex-col bg-slate-50 p-4 rounded-xl"
};
const _hoisted_7 = {
  class: "flex-center"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "flex flex-col text-slate-50 p-2"
};
const _hoisted_10 = /*#__PURE__*/_createTextVNode("--");
const _hoisted_11 = {
  class: "flex-center flex-col bg-slate-50 p-4 rounded-xl"
};
const _hoisted_12 = {
  key: 0,
  class: "text-red-700 mt-1"
};
const _hoisted_13 = {
  key: 1,
  class: "flex flex-col"
};
import { app } from "@/di";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
import { Team } from "@/modules/team/entity";
import Flag from "@/modules/vue/components/Flag.vue";
import PlayerInfo from "@/modules/team/components/PlayerInfo.vue";
import Talent from "@/modules/youth/components/Talent.vue";
import Gate from "@/modules/action-points/components/Gate.vue";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import NewcomerYouthPlayerFactory from "@/modules/youth/services/factories/NewcomerYouthPlayerFactory";
import { NewcomerRecruiter } from "@/modules/youth/services/NewcomerRecruiter";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import ConfirmationButton from "@/modules/vue/components/ConfirmationButton.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'NewcomersPage',
  async setup(__props) {
    let __temp, __restore;
    const players = ref();
    const team = ref();
    const selectedPlayers = ref({});
    const selectedPlayersCount = computed(() => Object.keys(selectedPlayers.value).filter(k => selectedPlayers.value[k]).length);
    const limit = ref(0);
    const newcomerRecruiter = app.get(NewcomerRecruiter);
    const scoutingCost = ref(app.get(ConfigRepository).get('scouting.actionPointsCosts.newcomers'));
    const negotiationCost = ref(app.get(ConfigRepository).get('scouting.actionPointsCosts.newcomers'));
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.createQueryBuilder('team').innerJoinAndSelect('team.country', 'country').innerJoinAndSelect('country.region', 'region').getOneOrFail();
      limit.value = await newcomerRecruiter.getLimit(team.value);
      players.value = await (await times(await newcomerRecruiter.getPlayerCount(team.value)).mapAsync(async () => app.get(NewcomerYouthPlayerFactory).make(team.value))).forEachAsync(p => p.save());
    })), __temp = await __temp, __restore(), __temp);
    const onScoutingTalent = async (commit, player) => {
      player.revelation = 100;
      await player.save();
      await commit();
    };
    const onContinue = async commit => {
      await Object.keys(selectedPlayers.value).filter(id => selectedPlayers.value[id]).forEachAsync(id => newcomerRecruiter.transfer(players.value.find(p => p.id == id), team.value));
      await players.value.forEachAsync(player => player.remove());
      if (commit) {
        await commit();
      }
      app.get(GlobalResolver).resolvePromise();
    };
    return (_ctx, _cache) => {
      const _component_NSwitch = _resolveComponent("NSwitch");
      const _component_NCarouselItem = _resolveComponent("NCarouselItem");
      const _component_NCarousel = _resolveComponent("NCarousel");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-tabbar": "",
        "hide-footer": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('newcomers')), 1)]),
        subtitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('newcomers_selection_limit', {
          count: _unref(selectedPlayersCount),
          limit: limit.value
        })), 1)]),
        footerButtons: _withCtx(() => [_unref(selectedPlayersCount) === 0 ? (_openBlock(), _createBlock(ConfirmationButton, {
          key: 0,
          label: _ctx.$t('continue'),
          "no-reset": ""
        }, {
          default: _withCtx(({
            confirmed,
            type,
            label,
            attrs
          }) => [_createVNode(_component_NButton, _mergeProps(attrs, {
            secondary: "",
            size: "large",
            onClick: _cache[0] || (_cache[0] = $event => onContinue())
          }), null, 16)]),
          _: 1
        }, 8, ["label"])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(Gate, {
          size: "large",
          type: _ctx.GateTypeEnum.NEGOTIATION,
          value: negotiationCost.value * _unref(selectedPlayersCount),
          "no-reset": "",
          onAction: onContinue
        }, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('select_players', {
            count: _unref(selectedPlayersCount)
          })), 1)]),
          _: 1
        }, 8, ["type", "value"])]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_NCarousel, {
          "space-between": 30,
          loop: false,
          "slides-per-view": "auto",
          "centered-slides": "",
          class: "h-full",
          "show-arrow": "",
          "dot-type": "line"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(players.value, (player, i) => {
            return _openBlock(), _createBlock(_component_NCarouselItem, {
              key: i,
              style: {
                width: `90%`
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(player.name) + " (" + _toDisplayString(player.age) + ") ", 1), _createElementVNode("div", _hoisted_4, [_createVNode(Flag, {
                country: player.country,
                class: "mr-2"
              }, null, 8, ["country"]), _createTextVNode(" " + _toDisplayString(player.country.name) + ", " + _toDisplayString(player.country.region.name), 1)]), _createElementVNode("div", _hoisted_5, _toDisplayString(player.position), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(PlayerInfo, {
                unknown: !player.isFullyRevealed,
                class: "mr-2"
              }, {
                default: _withCtx(() => [!player.isFullyRevealed ? (_openBlock(), _createElementBlock("div", _hoisted_8, "00")) : (_openBlock(), _createElementBlock(_Fragment, {
                  key: 1
                }, [_createTextVNode(_toDisplayString(Math.floor(player.skill)), 1)], 64))]),
                _: 2
              }, 1032, ["unknown"]), _createVNode(PlayerInfo, {
                unknown: !player.isFullyRevealed
              }, {
                default: _withCtx(() => [_createVNode(Talent, {
                  talent: player.isFullyRevealed ? player.talent : null,
                  size: "3rem"
                }, null, 8, ["talent"])]),
                _: 2
              }, 1032, ["unknown"])])]), _createElementVNode("div", _hoisted_9, [_createVNode(FormGroup, {
                label: _ctx.$t('wage'),
                class: "w-full",
                "value-width-ratio": .5
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$moneyPerMonth(player.wage)), 1)]),
                _: 2
              }, 1032, ["label"]), _createVNode(FormGroup, {
                label: _ctx.$t('market_value'),
                class: "w-full",
                "value-width-ratio": .5
              }, {
                default: _withCtx(() => [player.isFullyRevealed ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_createTextVNode(_toDisplayString(_ctx.$moneyPerMonth(player.marketValue)), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                  key: 1
                }, [_hoisted_10], 64))]),
                _: 2
              }, 1032, ["label"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_NSwitch, {
                value: selectedPlayers.value[player.id],
                "onUpdate:value": $event => selectedPlayers.value[player.id] = $event,
                size: "large",
                disabled: limit.value <= _unref(selectedPlayersCount) && !selectedPlayers.value[player.id]
              }, {
                checked: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('selected')), 1)]),
                unchecked: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('unselected')), 1)]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "disabled"]), limit.value <= _unref(selectedPlayersCount) && !selectedPlayers.value[player.id] ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('limit_of_player_count_reached')), 1)) : _createCommentVNode("", true), !player.isFullyRevealed ? (_openBlock(), _createBlock(Gate, {
                key: 1,
                type: _ctx.GateTypeEnum.SCOUTING,
                value: scoutingCost.value,
                class: "mt-4",
                onAction: $event => onScoutingTalent($event, player)
              }, null, 8, ["type", "value", "onAction"])) : _createCommentVNode("", true)])])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
});